/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import {
  CustomerListResponse,
  InventoryProductListApiResponse,
  SalesOrderApiResponse,
  SalesOrderDetailsApiResponseById,
  SalesOrderHistoryResponse,
  SalesOrderUpdateResponseWithUnknownProps
} from "../../@types/DRO/SalesOrderResponse";
import {
  CreateSalesOrderBody,
  CreateSalesOrderBodyReturn,
} from "../../@types/DTO/CreateSalesOrderBody";
import { UpdateSalesOrderRequestDto } from "../../@types/DTO/UpdateSalesOrderBody";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class SalesOrderApi {
  public static api = new SalesOrderApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllSalesOrders(
    page: number,
    pageSize: number,
    search: string,
    type: string,
    statusFilter?: string,
    customerFilter?: string,
    partCondition?: string
  ): Promise<SalesOrderApiResponse> {
    try {
      const response: AxiosResponse<SalesOrderApiResponse> =
        await this.instance.get("/erp/api/v1/inventory/sales/all", {
          params: {
            page,
            pageSize,
            search,
            type,
            statusFilter,
            customerFilter,
            partCondition,
          },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching sales orders:", error);
      throw error;
    }
  }

  async createSalesOrder(orderBody: CreateSalesOrderBody): Promise<void> {
    try {
      await this.instance.post(
        `/erp/api/v1/inventory/product/sale`,
        orderBody,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }

  async closeSalesOrder(
    orderBody: UpdateSalesOrderRequestDto
  ): Promise<SalesOrderUpdateResponseWithUnknownProps> {
    try {
      const response: AxiosResponse<SalesOrderUpdateResponseWithUnknownProps> =
        await this.instance.post(`/erp/api/v1/inventory/close/so`, orderBody, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error creating Sales order", error);
      throw error;
    }
  }
  async createSalesOrderReturn(
    orderBody: CreateSalesOrderBodyReturn
  ): Promise<SalesOrderUpdateResponseWithUnknownProps> {
    try {
      const response: AxiosResponse<SalesOrderUpdateResponseWithUnknownProps> =
        await this.instance.post(`/erp/api/v1/order/return/close`, orderBody, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }

  async getSingleSalesOrderDetails(
    id: number | null
  ): Promise<SalesOrderDetailsApiResponseById> {
    try {
      const response: AxiosResponse<SalesOrderDetailsApiResponseById> =
        await this.instance.get(`/erp/api/v1/inventory/sales/details/${id}`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async getSingleSalesOrderReturnDetails(
    id: number | null
  ): Promise<SalesOrderDetailsApiResponseById> {
    try {
      const response: AxiosResponse<SalesOrderDetailsApiResponseById> =
        await this.instance.get(
          `/erp/api/v1/order/return/details/sales/${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async getInventoryProductListByWarehouseId(
    warehouseId: number | null
  ): Promise<InventoryProductListApiResponse> {
    try {
      const response: AxiosResponse<InventoryProductListApiResponse> =
        await this.instance.get(`/erp/api/v1/inventory/product/list`, {
          params: { warehouseId },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching inventory product list", error);
      throw error;
    }
  }

  async getAllCustomerListForSalesOrder(
    page?: number,
    pageSize?: number,
    search?: string
  ): Promise<CustomerListResponse> {
    try {
      const response: AxiosResponse<CustomerListResponse> =
        await this.instance.get("/erp/api/v1/customer/all", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page,
            pageSize,
            search,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }
  async createCustomerForSalesOrder(qrCode: any): Promise<void> {
    try {
      await this.instance.post(`/erp/api/v1/customer/create`, qrCode, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }


  // inside class SalesOrderApi
  async getSalesOrderHistory(id: number): Promise<SalesOrderHistoryResponse> {
    try {
      const response: AxiosResponse<SalesOrderHistoryResponse> =
        await this.instance.get(`/erp/api/v1/inventory/sales-order/history`, {
          params: { id },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching sales order history:", error);
      throw error;
    }
  }
}

